import { IUserdataType } from "@/types/GlobalTypes";

const locales = {
    "cn": "cn-CN",
    "en": "en-US",
    "id": "id-ID",
    "th": "th-TH",
    "vn": "vn-VN",
};

export type langLiteralType = "cn" | "en" | "id" | "th" | "vn";

//Fetches language data
//New Language Request
function fetchLanguageData(mainClass: any, lang: string) {
	const data = require("../lang/lang-" + lang.toLowerCase()).default;

	// console.log(data);

	mainClass.setState({ lang: data });
}

function loadLanguage(userdat: IUserdataType) {
	const langStr = localStorage.getItem("lang");

	userdat.user.lang = ((langStr) ? langStr :
	//Mutates received language to lower case
		userdat.user.lang.toLowerCase()) as langLiteralType;
}

function saveLanguage(newLanguage: string) {
	localStorage.setItem("lang", newLanguage);
}

function updateLanguage(e: any): void {
	const newLang = e.currentTarget.value

	saveLanguage(newLang);

	//Updates language without reloading
	if (this) {
		fetchLanguageData(this, newLang);
		
		const userdat = this.state.userdata;
		userdat.user.lang = newLang;
		this.setState({userdata: userdat});
	}
}

export {
    locales,

    // Language Support
	fetchLanguageData, loadLanguage, saveLanguage, updateLanguage,
}
